import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// add point listing of inspections
import { AddPointInspectionListComponent } from '../components/addPoint/inspection-list.component';
// add point listing of sections
import { AddPointSectionListComponent } from '../components/addPoint/section-list.component';
// add point listing of points
import { AddPointPointListComponent } from '../components/addPoint/point-list.component';
// create new Section
import { NewSectionPageComponent } from '../pages/new.component';
import { NewSectionComponent } from '../components/new.component';

import { InspectionSectionEditComponent } from '../components/edit.component';

import { routedComponents, SectionEditorRoutingModule } from './section-editor.routing';

import { SharedModule } from '../../shared.module';

@NgModule({
  imports: [CommonModule, SharedModule, SectionEditorRoutingModule, FormsModule, ReactiveFormsModule],
  declarations: [
    routedComponents,
    AddPointInspectionListComponent,
    AddPointSectionListComponent,
    AddPointPointListComponent,
    NewSectionPageComponent,
    NewSectionComponent,
    InspectionSectionEditComponent
  ]
})
export class SectionEditorModule {}
